import format from 'date-fns/format';
import formatDuration from 'date-fns/formatDuration';
import intervalToDuration from 'date-fns/intervalToDuration';
import isToday from 'date-fns/isToday';
import isTomorrow from 'date-fns/isTomorrow';

import { EventType } from '../../../../session/interfaces';

export const purposes = [
  {
    value: EventType.Lecture,
    label: 'Guided Class',
    description: 'An environment optimized for learning',
  },
  {
    value: EventType.Exam,
    label: 'Live Quiz',
    description: 'Best for in-class assessments',
  },
];

export const getFormattedDate = (
  timeStamp: Date | string,
  isNext: boolean,
  dateFormat: string = 'do LLLL, ',
) => {
  const time = new Date(timeStamp);
  if (isNext) {
    return formatDuration(
      intervalToDuration({
        start: time,
        end: new Date(),
      }),
      {
        format: ['weeks', 'days', 'hours', 'minutes'],
      },
    );
  }
  if (isToday(time)) {
    return 'Today, ';
  }
  if (isTomorrow(time)) {
    return 'Tomorrow, ';
  }
  return format(time, dateFormat);
};

export function getCurrentDateRoundToHour() {
  const d = new Date();
  d.setMinutes(d.getMinutes() + 59);
  d.setMinutes(0);
  d.setSeconds(0);
  return d;
}
